import { useTranslation } from 'react-i18next';

interface ShareDeviceDialogContentFullyBookedProps {
  onConfirm: () => void;
}

export const ShareDeviceDialogContentFullyBooked = ({
  onConfirm,
}: ShareDeviceDialogContentFullyBookedProps) => {
  const { t } = useTranslation();

  return (
    <div className="dialog__line">
      <div className="dialog__area">
        <div className="dialog__text">
          <p className="dialog__text-line dialog__text-line-left">
            {t('shareDevice.complete.fullyBookedDialog.line1')}
            <br />
            {t('shareDevice.complete.fullyBookedDialog.line2')}
            <br />
            {t('shareDevice.complete.fullyBookedDialog.line3')}
          </p>
        </div>
        <div className="f4__actions">
          <button
            className="dialog__btn dialog__btn--ok js-bt-dialog"
            type="button"
            onClick={onConfirm}
          >
            {t('shareDevice.complete.fullyBookedDialog.okButton')}
          </button>
        </div>
      </div>
    </div>
  );
};
